<script setup lang="ts">
const year = new Date().getFullYear()
</script>

<template>
  <footer class="site-footer">
    <div class="footer-rule" aria-hidden="true"></div>
    <div class="footer-inner">
      <div class="colophon">
        <p class="colophon-line">
          <span class="brand">Castle Country Digital</span>
          <span class="dot" aria-hidden="true">·</span>
          <span class="muted">Castle Dale, Utah</span>
        </p>
        <p class="tagline">
          <em>A one-person shop, working across Carbon and Emery County.</em>
        </p>
      </div>
      <dl class="meta">
        <div>
          <dt>Call</dt>
          <dd><a href="tel:+13853014032">(385) 301-4032</a></dd>
        </div>
        <div>
          <dt>Email</dt>
          <dd>
            <a href="mailto:dallan.baker@castlecountrydigital.com">
              dallan.baker@castlecountrydigital.com
            </a>
          </dd>
        </div>
        <div>
          <dt>©</dt>
          <dd>{{ year }}</dd>
        </div>
      </dl>
    </div>
  </footer>
</template>

<style scoped>
.site-footer {
  max-width: var(--max-w);
  margin: 5rem auto 1.5rem;
  padding: 0 1.5rem;
}

.footer-rule {
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    var(--border) 10%,
    var(--border-bright) 50%,
    var(--border) 90%,
    transparent 100%
  );
  margin-bottom: 1.75rem;
}

.footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  flex-wrap: wrap;
}

.colophon {
  max-width: 28em;
}

.colophon-line {
  margin: 0 0 0.4rem;
  font-family: var(--font-display);
  font-size: 1.05rem;
  letter-spacing: -0.005em;
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.brand {
  color: var(--text);
  font-weight: 500;
}

.dot {
  color: var(--text-faint);
}

.muted {
  color: var(--text-muted);
  font-family: var(--font-display);
  font-size: 0.95rem;
}

.tagline {
  margin: 0;
  font-family: var(--font-display);
  font-size: 0.95rem;
  color: var(--text-muted);
  letter-spacing: 0.005em;
}
.tagline em {
  font-style: italic;
  color: var(--accent-bright);
  font-variation-settings: 'opsz' 24;
}

.meta {
  margin: 0;
  display: grid;
  grid-template-columns: repeat(3, auto);
  gap: 1.4rem;
  align-items: start;
}
.meta div {
  margin: 0;
}

.meta dt {
  font-family: var(--font-mono);
  font-size: 0.6rem;
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--text-faint);
  margin-bottom: 0.3rem;
}

.meta dd {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 0.78rem;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}

.meta dd a {
  color: var(--text-muted);
  text-decoration: none;
}
.meta dd a:hover {
  color: var(--accent-bright);
  text-decoration: underline;
  text-underline-offset: 3px;
}

@media (max-width: 600px) {
  .meta {
    grid-template-columns: repeat(2, auto);
    gap: 1rem 1.4rem;
  }
}
</style>
